import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/homeData';

export default function TopNav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? 'border-background-200 bg-background-50/95 backdrop-blur-md'
          : 'border-transparent bg-background-50'
      }`}
    >
      <div className="flex h-16 w-full items-center justify-between gap-4 px-4 md:px-8">
        <a href="#top" className="flex cursor-pointer items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-background-50">
            <i className="ri-flashlight-fill text-lg leading-none"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base font-bold tracking-tight text-foreground-950">
              网爆黑料
            </span>
            <span className="mt-1 font-label text-[11px] tracking-[0.18em] text-foreground-500">
              证据链深扒
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer rounded-md px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <span className="hidden items-center gap-2 font-label text-xs text-foreground-600 lg:flex">
            <span className="h-2 w-2 animate-pulse-dot rounded-full bg-accent-500"></span>
            实时梳理中
          </span>
          <a
            href="#clues"
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-search-eye-line text-base leading-none"></i>
            进入深扒台
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl leading-none`}></i>
          </button>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer border-b border-background-100 py-3 text-sm text-foreground-700"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#clues"
            onClick={() => setOpen(false)}
            className="mt-4 inline-flex w-full cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            <i className="ri-search-eye-line text-base leading-none"></i>
            进入深扒台
          </a>
        </div>
      ) : null}
    </header>
  );
}